import React from 'react';
import { Database, FileWarning, Lock, AlertOctagon } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Data Leaks feature
 * Displays information about the Data Leaks feature and its benefits
 */
export const DataLeaksFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Data Leaks Monitoring"
      description="Detect and respond to sensitive data leaks and unauthorized disclosures that could impact your organization's security posture."
      icon={<Database className="h-8 w-8 text-blue-600" />}
      featureName="data-leaks"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <FileWarning className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Sensitive Data Detection</h3>
          </div>
          <p className="text-gray-400">
            Identify leaked sensitive data including source code, configuration files, and internal documents across the web.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Database className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Data Classification</h3>
          </div>
          <p className="text-gray-400">
            Automatically classify leaked data by sensitivity level and potential impact to prioritize remediation efforts.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertOctagon className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Risk Assessment</h3>
          </div>
          <p className="text-gray-400">
            Evaluate the potential security impact of data leaks with comprehensive risk assessment and exposure analysis.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Lock className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Remediation Guidance</h3>
          </div>
          <p className="text-gray-400">
            Get actionable recommendations to contain data leaks, revoke exposed credentials, and prevent future incidents.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
